import React from 'react';
import {Avatar} from '@udemy-v2/react-core-components';
import {ShowMore} from '@udemy-v2/react-reveal-components';
import {useI18n, RelativeDuration} from '@udemy-v2/i18n';

import styles from './instructor-response.module.scss';

// Define a basic type for the user prop (replace with actual type if available)
interface UserProfile {
    display_name: string;
    image_50x50: string;
    tracking_id: string;
    name: string;
    // Add other expected user properties if needed
}

// Define the props interface
export interface InstructorResponseProps {
    user?: UserProfile | null;
    content?: React.ReactNode | null;
    formattedTimestampSince?: string | null;
}

export const InstructorResponse: React.FC<InstructorResponseProps> = ({
    user = null,
    content = null,
    formattedTimestampSince = null,
}) => {
    const {gettext} = useI18n();

    if (!user || !content) {
        return null;
    }

    return (
        <div className={`ud-text-sm ${styles.response}`}>
            <div className={styles.author}>
                <Avatar
                    data-purpose="avatar"
                    user={user}
                    srcKey="image_50x50"
                    size="medium"
                    alt="NONE"
                />
                <div className={styles['author-content']}>
                    <p className={`ud-heading-md ${styles.name}`} data-purpose="instructor-name">
                        {user.display_name}
                    </p>
                    <p className={`ud-text-sm ${styles['author-description']}`}>
                        <span>{gettext('Instructor response')}</span>
                        {formattedTimestampSince && (
                            <>
                                <span className={styles.dot}>{' • '}</span>
                                <span data-purpose="formatted-timestamp-since">
                                    <RelativeDuration datetime={formattedTimestampSince} />
                                </span>
                            </>
                        )}
                    </p>
                </div>
            </div>

            <ShowMore collapsedHeight={100} withGradient={true} className={styles.body}>
                <div className={styles.comment} data-purpose="content">
                    {content}
                </div>
            </ShowMore>
        </div>
    );
};
